import { render, staticRenderFns } from "./PlatformAnalyticsSummary.vue?vue&type=template&id=074244df&scoped=true"
import script from "./PlatformAnalyticsSummary.vue?vue&type=script&lang=js"
export * from "./PlatformAnalyticsSummary.vue?vue&type=script&lang=js"
import style0 from "./PlatformAnalyticsSummary.vue?vue&type=style&index=0&id=074244df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074244df",
  null
  
)

export default component.exports